import { Asset, Customer, OrderCreateModel, OrderRequiredFieldSettings } from '../Interfaces'

export type CreateOrderActionTypes = UpdateOrderToCreateAction | SetShouldSaveOrderLocationAction | SetSelectedCustomerAction | SetSelectedAssetAction | UpdateOrderRequiredFieldSettingsAction;

export const UPDATE_ORDER_TO_CREATE = "UPDATE_ORDER_TO_CREATE";
export interface UpdateOrderToCreateAction {
    type: typeof UPDATE_ORDER_TO_CREATE;
    updateOrderToCreateActionPayload: UpdateOrderToCreateActionPayload;
}

export const SET_SHOULD_SAVE_ORDER_LOCATION = "SET_SHOULD_SAVE_ORDER_LOCATION";
export interface SetShouldSaveOrderLocationAction {
    type: typeof SET_SHOULD_SAVE_ORDER_LOCATION;
    shouldSaveOrderLocation: boolean;
}

export const SET_SELECTED_ASSET = "SET_SELECTED_ASSET";
export interface SetSelectedAssetAction {
    type: typeof SET_SELECTED_ASSET;
    setSelectedAssetPayload: SetSelectedAssetActionPayload;
}

export const SET_SELECTED_CUSTOMER = "SET_SELECTED_CUSTOMER";
export interface SetSelectedCustomerAction {
    type: typeof SET_SELECTED_CUSTOMER;
    setSelectedCustomerPayload: SetSelectedCustomerActionPayload;
}

export const UPDATE_ORDER_REQUIRED_FIELD_SETTINGS = "UPDATE_ORDER_REQUIRED_FIELD_SETTINGS";
export interface UpdateOrderRequiredFieldSettingsAction {
    type: typeof UPDATE_ORDER_REQUIRED_FIELD_SETTINGS;
    updateOrderRequiredFieldSettingsPayload: UpdateOrderRequiredFieldSettingsPayload;
}

export interface UpdateOrderToCreateActionPayload {
    orderToCreate:  OrderCreateModel   
}

export interface SetSelectedAssetActionPayload {
    selectedAsset?: Asset
}

export interface SetSelectedCustomerActionPayload {
    selectedCustomer?: Customer
}

export interface UpdateOrderRequiredFieldSettingsPayload {
    orderRequiredFieldSettings: OrderRequiredFieldSettings   
}